import uniqueId from 'lodash/uniqueId';
import DK from 'utils/dictionaries/filter_dictionary';

export type TStateValue = [string, string, string[]];
export type TStateItem = { id: string; value: TStateValue };

export const getDefaultSelect = (): TStateItem => ({
  id: uniqueId(),
  value: ['', '', ['']],
});

export const mapSelect = (val: TStateValue): TStateItem => ({
  id: uniqueId(),
  value: [val[0] || '', val[1] || '', val[2] || ['']],
});

export const formatDate = (date: Date) => date.getTime().toString();

export const retrieveDate = (props: (string | null)[]) => {
  const [startDate, endDate] = props || [];
  return {
    startDate: startDate ? new Date(parseInt(startDate, 10)) : undefined,
    endDate: endDate ? new Date(parseInt(endDate, 10)) : undefined,
  };
};

export const applyOverride = (operator: string, featureExc1365: boolean) => {
  if (operator === DK.WITHIN) {
    return 'DatePicker';
  }
  if (operator === DK.CONTAINS && featureExc1365) {
    return 'InputField';
  }
  if (operator === DK.CONTAINS) {
    return 'Input';
  }
  return null;
};
